import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    pageTitle: ""
};

const currentPageSlice = createSlice({
    name: "currentPage",
    initialState,
    reducers: {
        changePageTitle: (state, action) => {
            state.pageTitle = action.payload;
            document.title = action.payload + " | Veronica Virta";
        }
    }
});

export const { changePageTitle } = currentPageSlice.actions;
export default currentPageSlice.reducer;